import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
} from 'react'

export type MessageCenterTabLayerContextValue = {
  setTabLayerActions: Dispatch<SetStateAction<ReactNode | null>>
}

const MessageCenterTabLayerContext =
  createContext<MessageCenterTabLayerContextValue | null>(null)

export function MessageCenterTabLayerProvider({
  value,
  children,
}: {
  value: MessageCenterTabLayerContextValue
  children: React.ReactNode
}): React.ReactElement {
  return (
    <MessageCenterTabLayerContext.Provider value={value}>
      {children}
    </MessageCenterTabLayerContext.Provider>
  )
}

export function useMessageCenterTabLayer(): MessageCenterTabLayerContextValue {
  const ctx = useContext(MessageCenterTabLayerContext)
  if (!ctx) {
    throw new Error(
      'useMessageCenterTabLayer must be used within MessageCenterTabLayerProvider',
    )
  }
  return ctx
}
